


  class Main_Cart {

    constructor() {
      this.on_cart_page = false;
      this.localCartObject = null;
      this.sidecart_cart_full_container = document.getElementById("side_cart");
      this.sidecart_cart_table = document.getElementById("side_cart_table");
      this.sidecart_cart_table_tbody = this.sidecart_cart_table.querySelector("tbody");
      this.sidecart_cart_totals_area = this.sidecart_cart_full_container.querySelector(".total_prices");
      this.cartpage_cart_table = false;
      this.cartpage_cart_table_tbody = false;
      this.cartpage_cart_totals_area = false;
      this.cart_table_visual_items = [];
      this.restore_items_data = {};
      this.skeleton_node__sidecart = null;
      this.skeleton_node__cart_page = null;
      this.side_cart_number_container = document.querySelector(".mini-cart-wrap .item-count");
    }


    /* ------ Core Mechanics ------ */

    async init(){
      // Check if on cart page
      this.utility__check_is_cart_page();
      // Define Skeleton Node
      this.utility__create_line_item_skeleton_node();
      // await this.refresh();
      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Object_Created"));
    }


    async refresh(){

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Refresh_Begin"));

      /* Collects server side cart data */
      this.localCartObject = false;
      await this.utility__fetch_update_local_cart_object();


      // Populate Table & Update Totals
      if(this.localCartObject) {
        // Populate Line Items
        this.UI_Populate_Cart();
        // Populate Cart-End Totals Area

        if(this.sidecart_cart_totals_area) {
          this.UI_update_cart_totals(this.sidecart_cart_totals_area);
        }
        if(this.cartpage_cart_totals_area) {
          this.UI_update_cart_totals(this.cartpage_cart_totals_area);
        }
      }

      // Handles Empty Display
      if(this.localCartObject.items.length === 0) {
        this.is_cart_empty(true);
        this.side_cart_number_container.display = "none";
        this.side_cart_number_container.innerText = "";
      }
      else {
        this.is_cart_empty(false);
        this.side_cart_number_container.display = "";
        this.side_cart_number_container.innerText = this.localCartObject.items.length;
      }

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Refresh_End"));

    }


    // [R] Updates the quantity of an item in the [SC_Cart] via Cart.js JSON Parameter
    async update_items(updates_json) {

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Update_Items_Begin"));

      /*
      updates_json = {
        "8844296:9f461ae6": 2,
        40980763476104: 3
      }
      */
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates: updates_json }), // The key should be 'updates'
        });
    
        if (!response.ok) {
          console.error('Failed to update cart items');
          const errorData = await response.json(); // Await the error response if necessary
          console.log('Error response:', errorData);
      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Update_Items_Failure"));
          return false;
        }
    
        const data = await response.json();
        console.log('Cart updated successfully:', data);

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Update_Items_Success"));
        await this.refresh(); // Assuming `this.refresh()` is an async function

        document.body.classList.remove("cart_timeout");
        return true;

      } catch (error) {
        console.error('Error updating cart:', error);
        document.body.classList.remove("cart_timeout");
        return false;
      }
    }


    /* ------ User Invoked Functions ------ */

    // Increments [V_Cart] lineitem quantity via the button arrows
    lineitem_quantity_up_down(node, direction){

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Quantity_Change_Request"));

      const cart_item = node.closest(".cart_item");
      const input_box = node.parentElement.querySelector("input");
      var empty = false;
      var allow_adjustment = true;
      var current_input_value = parseInt(input_box.value);
      var new_value = current_input_value + (direction);

      if(direction === -1 && current_input_value == 0) {
        input_box.value = 0;
      }
      else {
        input_box.value = new_value;
      }

      input_box.disabled = true;

      if (window.cart_press_timeout) clearTimeout(window.cart_press_timeout);
      window.cart_press_timeout = setTimeout(() => {
        this.lineitem_update_quantity(input_box);
      }, 500);

    }

    // [R] Takes the value of the quantity from the quantity input box and applies it
    lineitem_update_quantity(node) {

    /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */ document.dispatchEvent(new Event("Cart__Quantity_Update_Post"));

      console.log("%c lineitem_update_quantity() called", "color: rgb(136, 68, 245)");

      node.disabled = true;

      var valid = true;
      var item_quantity = parseInt(node.value);
      var item_max = parseInt(node.max);
      const cart_item = node.closest(".cart_item");
      var item_LIK = cart_item.getAttribute("data-line-item-key");
      var item_VID = cart_item.getAttribute("data-variant-id");

      if(typeof(item_max) == 'number') {

        var found_vid = this.utility__find_input_liquid_product(item_VID, "variant");

        if(found_vid) {
          item_max = found_vid.variant_max_quantity;
          cart_item.setAttribute("max", item_max);
        }
        
      }

      if(typeof(item_quantity) !== 'number') {
        const local_object_item = this.localCartObject.items.find(i => i.variant_id === item_VID);
        if(local_object_item) {
          node.value == local_object_item.quantity;
          valid = false;
        }
      }

      if(valid) {
        
        const json_msg = {};
        json_msg[item_LIK] = item_quantity;

        if(item_quantity > item_max ) {
          this.utility__notify_stock_exceeded(cart_item, true);
          node.value = item_max;      
          json_msg[item_LIK] = item_max;
        }

        document.body.classList.add("cart_timeout");
        this.update_items(json_msg);

      }

    }

    // [R] Add a new item to the [S_Cart]
    add_items(form_data_array, success_callback, failure_callback){

      

      // Store the max quantity value in the input_liquid_data object
      form_data_array.forEach(item => {
        
        var vid_string_key = (item.id).toString();
        var found_vid = this.utility__find_input_liquid_product(vid_string_key, "variant");

        if(found_vid) {
          if(item.max) {
            if(found_vid) {
              found_vid.variant_max_quantity = item.max;
            }
          }
          else {
            found_vid.variant_max_quantity = 99;
          }
        }
        else {
          console.log("Unfound VID in add_items()");
        }

      });


      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Added_Item_Request"));

      console.log("%c add_items() called", "color: rgb(136, 68, 245)");


      var form_data = {'items': form_data_array };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form_data)
      })
      .then(response => {
        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Added_Item_Sent"));
          console.log(response);
          if(success_callback) {
            success_callback();
          }
          return response.json();
      })
      .then(() => {
      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Added_Item_Success"));
        this.refresh();
      })
      .catch((error) => {
        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Added_Item_Failure"));
        console.error('Error:', error);
        if(failure_callback) {
          failure_callback();
        }
      });
    }

    // Remove item from cart (wrapper of this.update_items())
    remove_line_item_from_cart(lik_or_vid_or_node, e){
      e.preventDefault();
      e.stopPropagation();

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Removed_Line_Item_Request"));

      var msg_ = false;
      if(typeof(lik_or_vid_or_node) === 'string') {
        // Line Item Key
        msg_ = lik_or_vid_or_node;
      }
      else if(typeof(lik_or_vid_or_node) === 'number') {
        // Line Item Variant ID
        msg_ = lik_or_vid_or_node;
      }
      else if(typeof(lik_or_vid_or_node) === 'object') {
        // HTML Node
        if(lik_or_vid_or_node.closest(".cart_item")) {
          const node_ = lik_or_vid_or_node.closest(".cart_item");
          if(node_.hasAttribute("data-line-item-key")) {
            msg_ = node_.getAttribute("data-line-item-key");
          }
          else if(node_.hasAttribute("data-variant-id")) {
            msg_ = node_.getAttribute("data-variant-id"); 
          }
        }
      }
      /* Cannot detect what data type passed into function is */
      if(msg_ == false) {
        console.error("Cart removal issue: 'Master Cart - remove_line_item_from_cart'");
        return;
      }
      const json_to_send = {};
      json_to_send[msg_] = 0;
      this.update_items(json_to_send);
    }


    /* ------ Utility Functions ------ */

    // Downloads the data of our [LC_Cart] from the cart.js endpoint
    async utility__fetch_update_local_cart_object(){

      console.log("%c utility__fetch_update_local_cart_object() called", "color: rgb(136, 68, 245)");

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Begin_Fetching_Cart_JS"));

      await fetch(window.Shopify.routes.root + 'cart.js', { 
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then(res => {
        if(res.status) {
          return res.json();
        }
        else {
          /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Error_Fetching_Cart_JS"));
          return;
        }

      })
      .then(res => {
        if(res) {
          this.localCartObject = res;
          /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Local_Cart_Object_Updated"));
          return true;
        }
        else {
          console.log("Failed to retrieve cart object");
          /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Error_Fetching_Cart_JS"));
          this.localCartObject = null;
        }
      })
    }


    // Show or hide stock notice notification
    utility__notify_stock_exceeded(cart_item, show_notification) {
      const input_box = cart_item.querySelector(".cart_product_quantity");
      if(show_notification) {
        if(cart_item.querySelectorAll(".stock_exceeded_warning").length === 0) {
          var msg = "Tyvärr har vi endast {{ stock }} i lager.";
          msg = msg.replace("--stock--", input_box.max);
          msg = msg.replace("{{ stock }} ", input_box.max);
          customNotification(msg, 3000);
        }
      }
      else {
        if(cart_item.querySelector(".stock_exceeded_warning")) {
          cart_item.querySelectorAll(".stock_exceeded_warning").forEach(element => element.remove());
        }
      }
    }


    utility__create_line_item_skeleton_node() {
      this.skeleton_node__sidecart = document.getElementById("skeleton_sidecart_item").querySelector(".cart_item").cloneNode(true);
      document.getElementById("skeleton_sidecart_item").remove();

      if(document.querySelector("#skeleton_cartpage_item")) {
        this.skeleton_node__cart_page = document.getElementById("skeleton_cartpage_item").querySelector(".cart_item").cloneNode(true);
        document.getElementById("skeleton_cartpage_item").remove();
      }
    }

    utility__check_is_cart_page(){
      if(document.querySelector("#cart_page_main_table")){
        this.on_cart_page = true;
        this.cartpage_cart_table = document.getElementById("cart_page_main_table");
        this.cartpage_cart_table_tbody = this.cartpage_cart_table.querySelector("tbody");
        this.cartpage_cart_full_container = document.getElementById("cart_page_outer_container");
        this.cartpage_cart_totals_area = this.cartpage_cart_full_container.querySelector(".totals");
      }
    }

    
    utility__find_input_liquid_product(search_id, search_query) {
      var found = false;
      if(this.input_liquid_data.products.length > 0) {

        for (const obj of this.input_liquid_data.products) {

          if(search_query == "product") {
            if(obj.product_id == search_id) {
              found = true;
              return obj;
            }
          }
          else if(search_query == "variant") {
            if(obj.variants.length > 0 && (!found)) {
              for (const variant of obj.variants) {
                if(variant.variant_id == search_id) {
                  found = true;
                  return variant;
                }
              };
            }
          }

        };

      }
      else {
        return false;
      }
    }


    /* ------ Visual Alterations ------ */

    display_sidecart(show, event) {
      if(show) {
        // Double checks and removes defaults . (notice_cart_empty is only hidden by default for google bot purposes)
        document.getElementById("side_cart").style.display = "";
        document.querySelector("#side_cart .notice_cart_empty").style.display = "";
        document.getElementById("side_cart_backdrop").style.display = "";
        
        if(event) {
          event.preventDefault();
          event.stopPropagation();
        }

        setTimeout(()=> {
          document.body.classList.add("sidecart_show");
          document.body.classList.add("sidecart_show_pre_anim");    
        }, 2); // Timeout is to allow display none to be changed above

        setTimeout(()=>{
          document.body.classList.remove("sidecart_show_pre_anim");
        }, 400);

        document.addEventListener("click", this.leave_side_cart_hit_event);

        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Side_Cart_Opened"));

      }
      else {
        document.body.classList.remove("sidecart_show");
        document.removeEventListener("click", this.leave_side_cart_hit_event);

        document.body.classList.add("sidecart_hide_pre_anim");
        setTimeout(()=>{
          document.body.classList.remove("sidecart_hide_pre_anim");
        }, 400);

        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Side_Cart_Closed"));

      }
    }

    is_cart_empty(show) {
      if(show) {
        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Updated_Is_Empty"));
        document.getElementById("side_cart_populated").style.display = "none";
        document.getElementById("side_cart_empty").style.display = "";
        if(this.on_cart_page) {
          document.getElementById("cart_page_populated").style.display = "none";
          document.getElementById("cart_page_empty_container").style.display = "";
        }
      }
      else {
        /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Updated_Is_Populated"));
        document.getElementById("side_cart_populated").style.display = "";
        document.getElementById("side_cart_empty").style.display = "none";
        if(this.on_cart_page) {
          document.getElementById("cart_page_populated").style.display = "";
          document.getElementById("cart_page_empty_container").style.display = "none";
        }
      }
    }

    leave_side_cart_hit_event = (e) => {
      if(!e.target.closest('#side_cart')) {
        this.display_sidecart(false, null);
      }
    }

    // Populates the cart with the correct line items
    UI_Populate_Cart() {
      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Populate_Cart_Start"));
      if(this.skeleton_node__sidecart || this.skeleton_node__cart_page) {

        const new_line_items__sidecart__arr = [];
        const new_line_items__maincart__arr = [];

        this.localCartObject.items.forEach((item, index) => {

          // Prepare Variables
          // - Title
          var title = item.product_title;
          var subtitle = false;
          if(title.includes("- ")) {
            var temp_title = title.split("- ");
            title = temp_title[0];
            subtitle = temp_title[1];
          }

          // UK Fix for cushions saying 'Covers'
          if(title.includes(" Cushion") && title.includes(" Cover") && item.variant_title.includes("With Filling")) {
            title = title.replace(" Cover", "");
          }


          // - Image URL
          var image_url = item.featured_image.url;
          var image_size__sidecart_cartpage = ["248x248", "248x248"]
          if(image_url.includes(".jpg")) {
            image_url = image_url.replace(".jpg", `_${image_size__sidecart_cartpage[0]}.jpg`);
          }
          else if(image_url.includes(".png")) {
            image_url = image_url.replace(".png", `_${image_size__sidecart_cartpage[0]}.png`);
          }
          else if(image_url.includes(".webp")) {
            image_url = image_url.replace(".webp", `_${image_size__sidecart_cartpage[0]}.webp`);
          }
          // - Prices
          var line_item_price, line_item_original_price, line_item_discount_savings;
          if(item.discounts.length > 0) {
            line_item_price = item.final_price;
            line_item_original_price = item.original_price;
            line_item_discount_savings = 0;
            for(var i = 0; i < item.discounts.length; i++) {
              line_item_discount_savings = line_item_discount_savings + item.discounts[i].amount;
            }
          }
          else {
            line_item_price = item.final_price;
            line_item_original_price = false;
            line_item_discount_savings = false;
          }


          // Discounts Applied String Array
          var discounts_applied_list = [];
          if(item.discounts.length > 0 && line_item_discount_savings !== 0) {
            item.discounts.forEach(discount_label => {
              discounts_applied_list.push(discount_label.title);
            });
          }

          // Max Quantities
          var variant_max_qty = false;

          var found_vid = this.utility__find_input_liquid_product((item.variant_id), "variant");

          if(found_vid) {
            variant_max_qty = found_vid.variant_max_quantity;
          }


          function prepare_output_node(skeleton_node, array_, location) {

            const new_node = skeleton_node.cloneNode(true);

            // Node Attributes
            new_node.setAttribute("data-cart-item-index", index);
            new_node.setAttribute("data-line-item-key", item.key);
            new_node.setAttribute("data-variant-id", item.variant_id);
            new_node.setAttribute("data-product-id", item.product_id);

            // Links
            new_node.querySelector(".cart_item_image a").href = item.url;
            new_node.querySelector(".cart_item_title a").href = item.url;

            // Title
            new_node.querySelector(".cart_item_title_main").innerText = parse_html(title);
      
            // Subtitle
            if(subtitle) {
              new_node.querySelector(".additional_header_txt").innerText = parse_html(subtitle);
            }
            else {
              if(new_node.querySelector(".additional_header_txt")) {
                new_node.querySelector(".additional_header_txt").remove();
              }
            }

            // Img
            if(location == "cart_page" ) {
              new_node.querySelector(".cart_item_image img").src = image_url.replace(image_size__sidecart_cartpage[0], image_size__sidecart_cartpage[1]);
            }
            else {
              new_node.querySelector(".cart_item_image img").src = image_url;
            }

            // Variant Title
            let variant_title = item.variant_title;
            if(variant_title?.includes(" +")) {
              variant_title = (variant_title.split(" +"))[0];
            }
            new_node.querySelector(".cart_item_variant_title").innerText = parse_html(variant_title);

            // Vendor
            new_node.querySelector(".cart_item_vendor").innerText = parse_html(item.vendor);

            // Current Price
            new_node.querySelector(".price").innerText = format_money_js(line_item_price, "integer");

            // Quantity
            new_node.querySelector("input.cart_product_quantity").value = item.quantity;
            // Max Quantity
            if(variant_max_qty) {
                new_node.querySelector("input.cart_product_quantity").max = (variant_max_qty + "");
            }

            if(new_node.querySelector(".remove_item")) {
              if(new_node.querySelector(".remove_item").href.includes("/#")) {
                new_node.querySelector(".remove_item").href = new_node.querySelector(".remove_item").href.replace("/#", ("/" + item.key));
              }
              else {
                new_node.querySelector(".remove_item").remove();
              }
            }
            
            // Original Price
            if(line_item_discount_savings && line_item_original_price > line_item_price) {
              new_node.querySelector(".original_price_outer .original_price").innerText = (format_money_js(line_item_original_price, "integer"));
            }
            else {
              if(new_node.querySelector(".original_price_outer")){
                new_node.querySelector(".original_price_outer").remove();
              }
            }

            // Discounted Savings
            if(line_item_discount_savings && line_item_discount_savings !== 0) {
              new_node.querySelector(".discount_savings_outer .discount_savings").innerText = "-" + (format_money_js(line_item_discount_savings, "integer"));
            }
            else {
              if(new_node.querySelector(".discount_savings_outer")) {
                new_node.querySelector(".discount_savings_outer").remove();
              }
            }

            
            // Discount Labels Applied
            if(new_node.querySelector(".discounts_applied .discount_list_item")) {
              if(discounts_applied_list.length > 0) {
                const discount_applied_nodes_list = [];
                discounts_applied_list.forEach(discount_label => {
                  const discount_applied_node = new_node.querySelector(".discounts_applied .discount_list_item").cloneNode();
                  discount_applied_node.innerText = discount_label;
                  discount_applied_nodes_list.push(discount_applied_node);
                });
                new_node.querySelector(".discounts_applied .discount_list_item").remove();
                discount_applied_nodes_list.forEach(node => {
                  new_node.querySelector(".discounts_applied").appendChild(node);
                  console.log(node);
                });
              }
              else {
                if(new_node.querySelector(".discounts_applied")) {
                  new_node.querySelector(".discounts_applied").remove();
                }
              }
            }


            // Push To Final Array
           
            array_.push(new_node);


          }

          // Cart Page Output
          if(this.on_cart_page && this.cartpage_cart_table && this.cartpage_cart_full_container) {
            if(this.skeleton_node__cart_page != null) {
              prepare_output_node(this.skeleton_node__cart_page, new_line_items__maincart__arr, "cart_page");
            }
            else {
              console.error("skeleton_node__cart_page == null");
            }
          }

          if(this.skeleton_node__sidecart != null) {
            prepare_output_node(this.skeleton_node__sidecart, new_line_items__sidecart__arr, "side_cart");
          }
          else {
            console.error("skeleton_node__side_page == null");
          }

        });


        if(this.sidecart_cart_table_tbody && new_line_items__sidecart__arr.length > 0) {
          this.UI_Remove_Line_Items();
          new_line_items__sidecart__arr.forEach(item => this.sidecart_cart_table_tbody.appendChild(item));
          if(this.on_cart_page && this.cartpage_cart_table_tbody && new_line_items__maincart__arr.length > 0){
            new_line_items__maincart__arr.forEach(item => this.cartpage_cart_table_tbody.appendChild(item));
          }
        }

      }
      else {
        console.error("No Skeleton Nodes can be found");
      }
      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Populate_Cart_End"));
    }

    // Update the lower cart totals area
    UI_update_cart_totals(totals_wrapper){

      if(this.localCartObject) {
        const subtotal_price = this.localCartObject.original_total_price;
        const total_price = this.localCartObject.total_price;
        const total_discount = this.localCartObject.total_discount;
        const cart_total_pre_row = totals_wrapper.querySelector(".cart_total_pre_row");

        // Update the price
        totals_wrapper.querySelector(".cart_totals_price").innerText = format_money_js(total_price, "integer");

        if(totals_wrapper.querySelector(".cart_total_pre_row_item.original_price_outer")) {
          totals_wrapper.querySelector(".cart_total_pre_row_item.original_price_outer").remove();
        }
        if(totals_wrapper.querySelector(".cart_total_pre_row_item.discount_savings")) {
          totals_wrapper.querySelector(".cart_total_pre_row_item.discount_savings").remove();
        }

        // Update the price discount and original price
        if(subtotal_price > total_price) {
          totals_wrapper.querySelector(".cart_totals_price").innerText = format_money_js(total_price, "integer"); 

        // Original Price HTML
          const subtotal_price_label = "Delsumma";
          const subtotal_price_value = format_money_js(subtotal_price, "integer");
          const subtotal_price_row = document.createElement("div");
          subtotal_price_row.classList = "cart_total_pre_row_item original_price_outer";
          subtotal_price_row.innerHTML = `
          <span class="cart_end_label">${subtotal_price_label}</span>
          <span class="cart_end_value">${subtotal_price_value}</span>
          `;

        // Discount HTML
          const discount_savings_label = "NA";
          const discount_savings_value = format_money_js(total_discount, "integer");
          const discount_savings_row = document.createElement("div");
          discount_savings_row.classList = "cart_total_pre_row_item discount_savings";
          discount_savings_row.innerHTML = `
          <span class="cart_end_label">${discount_savings_label}</span>
          <span class="cart_end_value">-${discount_savings_value}</span>
          `;

          cart_total_pre_row.appendChild(subtotal_price_row);
          cart_total_pre_row.appendChild(discount_savings_row);
        }

      }

      /* -Event Dispatcher ~~~~~~~~~~~~~~~~~~~~- */document.dispatchEvent(new Event("Cart__Totals_Area_Updated"));

    }

    // Remove All Line Items From Cart
    UI_Remove_Line_Items(){
      // Clear Table
      if(this.localCartObject) {
        // Side cart clear items
        Array.from(this.sidecart_cart_table.querySelectorAll(".cart_item")).forEach(div => div.remove());
        // Cart page clear items
        if(this.on_cart_page && this.cartpage_cart_table && this.cartpage_cart_full_container) {
          Array.from(this.cartpage_cart_table.querySelectorAll(".cart_item")).forEach(div => div.remove());
        }
      }
    }


  }





  // ----------------------------------------------------------------------
  /* Cart Service - Add Lineitem Upsell Items */
  
  class CARTSERVICE__Add_Line_item_Upsell_Items {
    constructor (cart){
      this.cart = cart;
      this.listen();
      this.visual_sidecart_items = [];
      this.visual_maincart_items = [];
      this.created_nodes = [];
      this.sc_upsell_container = false;
      this.mc_upsell_container = false;
      this.current_cart_variants = [];
      this.slider_rows = [];

      this.iterated_fabrics = [];
    }
    listen(){
      // Listen for cart object created and refresh events to then begin
      document.addEventListener("Cart__Object_Created", this.init.bind(this));
      document.addEventListener("Cart__Refresh_End", this.init.bind(this));
    }

    init(){
      try {

        this.slider_rows = [];
        this.visual_sidecart_items = [];
        this.visual_maincart_items = [];
        this.current_cart_variants = [];

        // Fabrics Array to determine if there are multiple fabrics
        this.iterated_fabrics = [];


        // if((Object.keys(this.cart.input_liquid_data.variants)).length > 0) {
        //   this.current_cart_variants = Object.keys(this.cart.input_liquid_data.variants);
        // }
        if(this.cart.sidecart_cart_table_tbody.querySelector(".cart_item")) {
          this.cart.sidecart_cart_table_tbody.querySelectorAll(".cart_item").forEach(cart_item => {
            this.current_cart_variants.push(cart_item.getAttribute("data-variant-id"));
          });
        }

        if(this.sc_upsell_container) {
          this.sc_upsell_container.remove();
          this.sc_upsell_container = false;
        }
        if(this.mc_upsell_container) {
          this.mc_upsell_container.remove();
          this.mc_upsell_container = false;
        }


        // Sidecart
        if(this.cart.sidecart_cart_table) {
          this.cart.sidecart_cart_table.querySelectorAll(".cart_item").forEach(cart_item => {
            this.visual_sidecart_items.push(cart_item);
          });
        }
        if(this.visual_sidecart_items.length > 0) {
          this.visual_sidecart_items.forEach(cart_item => { this.iterate_per_line_item(cart_item, true) });
        }

        // Main Cart
        if(this.cart.cartpage_cart_table && this.cart.on_cart_page) {
          this.cart.cartpage_cart_table.querySelectorAll(".cart_item").forEach(cart_item => {
            this.visual_maincart_items.push(cart_item);
          });
        }
        if(this.visual_maincart_items.length > 0) {
          this.visual_maincart_items.forEach(cart_item => { this.iterate_per_line_item(cart_item, false) });
        }

        if(this.slider_rows.length > 0) {
          this.slider_rows.forEach(row => {
            this.sliderize(row.querySelector(".cliuc_container"));
          });
        }
      }
      catch(err){
        console.error("CARTSERVICE__Add_Line_item_Upsell_Items - init() error: ", err);
      }

    }



    iterate_per_line_item(variant, is_sidecart){
      // Iterate throught line-item variants, and search for if liquid data is populated, and then append upsells

      var upsell_array = false;
      const variant_id = variant.getAttribute("data-variant-id");
      const product_id = variant.getAttribute("data-product-id");
      var prod_title = "";
      let prod_subtitle = false;
      let prod_fabric = null;
      
      let already_iterated_fabric = false;
      let already_iterated_fabrics_container = false;
      let already_iterated_fabric_productIDs = [];


      // Populate Upsell_Array, and get the lineitem product title, fabric and subtitle
      if(this.cart.utility__find_input_liquid_product(product_id, "product")) {
        if(this.cart.utility__find_input_liquid_product(product_id, "product").upsell_products.generic_upsells.length > 0) {
          upsell_array = this.cart.utility__find_input_liquid_product(product_id, "product").upsell_products.generic_upsells;
          prod_title = this.cart.utility__find_input_liquid_product(product_id, "product").product_title;
          if(prod_title.includes("- ")) {
            const split_array = (prod_title.split("- "));
            prod_title = split_array[0];
            prod_subtitle = split_array[1];
          }
          if(this.cart.utility__find_input_liquid_product(product_id, "product").product_fabric) {
            prod_fabric = this.cart.utility__find_input_liquid_product(product_id, "product").product_fabric;
          }
        }
      }
      else {
        console.log("failure to find liquid", {
          "variant_id": variant_id,
          "product_id": product_id
        });
      }

      // Check if there is a duplicate slider elsewhere
      if(this.iterated_fabrics.includes(prod_fabric)){
        let target = false;
        let base;
        is_sidecart ? base = this.sc_upsell_container : base = this.mc_upsell_container;

        if(base && base.querySelector(`.cart_linteitem_upsell_row_container[data-fabric-code="${prod_fabric}"]`)){
          already_iterated_fabrics_container = base.querySelector(`.cart_linteitem_upsell_row_container[data-fabric-code="${prod_fabric}"]`);

          // Replace subtitle to change product title to the fabric name
          if(this.cart.utility__find_input_liquid_product(product_id, "product").product_title && already_iterated_fabrics_container && prod_title) {
            if(prod_subtitle && already_iterated_fabrics_container.querySelector("._subheader span")){
              already_iterated_fabrics_container.querySelector("._subheader span").innerText = prod_subtitle;
            }
          }
          // Assign the already outputted products (so we can add the new ones to the pre-existing list)
          already_iterated_fabric = true;
          already_iterated_fabrics_container.querySelectorAll(".cart_upsell_lineitem").forEach(node => { if(node.hasAttribute("data-product-id")){ already_iterated_fabric_productIDs.push(node.getAttribute("data-product-id"))} } );
        }
      }
      else if(prod_fabric) {
        this.iterated_fabrics.push(prod_fabric);
      }

      if(is_sidecart && upsell_array) {

        // var sc_product_limit = 3;
        var sc_product_counter = 0;

        var sc_product_data_html = ``;

        // Check no variants in the upsell are already in the cart
        for(var i = 0; i < upsell_array.length; i++) {
          var valid = true;
          upsell_array[i].variants.forEach(variant => {
            if(this.current_cart_variants.includes((variant.variant_id).toString())){
              valid = false;
            }
          });

          // If an already iterated fabric, prevent duplicates being added to slider
          if(already_iterated_fabric && already_iterated_fabric_productIDs.length > 0) {
            if(already_iterated_fabric_productIDs.includes((upsell_array[i].product_id).toString())) {
              valid = false;
            }
          }

          if(valid) {
            if(this.format_product_item(upsell_array[i]) !== false){
              sc_product_data_html += this.format_product_item(upsell_array[i]);
              sc_product_counter++;
            }
          }
          // if(sc_product_counter === sc_product_limit) {
          //   break;
          // }
        }

        if(!already_iterated_fabric) {

          if(!this.sc_upsell_container) {
            this.sc_upsell_container = document.createElement("div");
            this.sc_upsell_container.classList = "cart_linteitem_upsell_container";
            this.cart.sidecart_cart_table.insertAdjacentElement("afterend", this.sc_upsell_container);
          }

          if(sc_product_data_html !== ``){
            const sc_lineitem_upsell_container = document.createElement("div");
            sc_lineitem_upsell_container.classList = "cart_linteitem_upsell_row_container";
            if(prod_fabric) sc_lineitem_upsell_container.setAttribute("data-fabric-code", prod_fabric);
            sc_lineitem_upsell_container.innerHTML = `
            <h3 class="_header">Matchar din:</h3>
            <p class="_subheader"><span>${ prod_title }</span></p>
            <div class="cliuc_container">
              <div class="cliuc_container_inner">
                ${sc_product_data_html}
              </div>
            </div>`;

            this.sc_upsell_container.appendChild(sc_lineitem_upsell_container);
            this.slider_rows.push(sc_lineitem_upsell_container);
            
            this.sc_upsell_container.setAttribute("data-containers", this.sc_upsell_container.querySelectorAll(".cart_linteitem_upsell_row_container").length);
          }

        }
        else if(already_iterated_fabrics_container) {
          const target_injection = already_iterated_fabrics_container.querySelector(".cliuc_container_inner");
          if(target_injection && sc_product_data_html !== ``) {
            target_injection.innerHTML += sc_product_data_html;
          }
        }
      }
      else if(upsell_array) {

        // var mc_product_limit = 3;
        var mc_product_counter = 0;
    
        var mc_product_data_html = ``;
    
         // Check no variants in the upsell are already in the cart
        for(var i = 0; i < upsell_array.length; i++) {
          var valid = true;
          upsell_array[i].variants.forEach(variant => { if(this.current_cart_variants.includes((variant.variant_id).toString())){ valid = false; } } );
    
          // If an already iterated fabric, prevent duplicates being added to slider
          if(already_iterated_fabric && already_iterated_fabric_productIDs.length > 0) {
            if(already_iterated_fabric_productIDs.includes((upsell_array[i].product_id).toString())) {
              valid = false;
            }
          }
    
          if(valid) {
            if(this.format_product_item(upsell_array[i]) !== false){
              mc_product_data_html += this.format_product_item(upsell_array[i]);
              mc_product_counter++;
            }
          }
        }
    
        if(!already_iterated_fabric) {
    
          if(!this.mc_upsell_container) {
            this.mc_upsell_container = document.createElement("div");
            this.mc_upsell_container.classList = "cart_linteitem_upsell_container";
            this.cart.cartpage_cart_full_container.querySelector("#cartpage_table_column").appendChild(this.mc_upsell_container);
          }
    
          if(mc_product_data_html !== ``){
            const mc_lineitem_upsell_container = document.createElement("div");
            mc_lineitem_upsell_container.classList = "cart_linteitem_upsell_row_container";
            if(prod_fabric) mc_lineitem_upsell_container.setAttribute("data-fabric-code", prod_fabric);
            mc_lineitem_upsell_container.innerHTML = `
            <h3 class="_header">Matchar din:</h3>
            <p class="_subheader"><span>${ prod_title }</span></p>
            <div class="cliuc_container">
              <div class="cliuc_container_inner">
                ${mc_product_data_html}
              </div>
            </div>`;
      
            this.mc_upsell_container.appendChild(mc_lineitem_upsell_container);
            this.slider_rows.push(mc_lineitem_upsell_container);
      
            this.mc_upsell_container.setAttribute("data-containers", this.mc_upsell_container.querySelectorAll(".cart_linteitem_upsell_row_container").length);
          }
        }
        else if(already_iterated_fabrics_container) {
          const target_injection = already_iterated_fabrics_container.querySelector(".cliuc_container_inner");
          if(target_injection && mc_product_data_html !== ``) {
            target_injection.innerHTML += mc_product_data_html;
          }
        }
    
      }
    
    }

    sliderize(row){

      function swiper_start(fnctn_row) {
        if(fnctn_row.children[0].children[0]) {
          fnctn_row.classList.add("swiper");
          fnctn_row.children[0].classList.add("swiper-wrapper");
          Array.from(fnctn_row.children[0].children).forEach(child => child.classList.add("swiper-slide"));
          new Swiper(null, {
            el: fnctn_row,
            slidesPerView: "auto",
            slidesPerGroupAuto: true,
            freeMode: {
              enabled: true,
              sticky: false,
              momentumVelocityRatio: 1.2,
            },
            speed: 250,
          });
        }
      }

      if(jQuery) {
        if ( jQuery.isReady ) {
          if(Swiper){
            swiper_start(row);
          }
        }
        else {
          jQuery("document").ready(function(){
            if(Swiper){
              swiper_start(row);
            }
          });
        }
      }

    }


    format_product_item(product_item) {
      var valid = true;

      if(product_item.variants.length > 0) {
        for(var i = 0; i < product_item.variants.length; i++) {
          if(product_item.variants[i].variant_max_quantity == 0) {
            valid = false;
            break;
          }
        }
      }
      if(valid == false) {
        return false;
      }

      if(product_item.product_available) {

        // Title
        var upsell_title = product_item.product_title;
        upsell_title.includes("- ") ? upsell_title = ((upsell_title.split("- "))[0]) : upsell_title = upsell_title;


        // UK Fix for cushions saying 'Covers'
        if(upsell_title.includes("Cushion") && upsell_title.includes(" Cover") && product_item.variants.length > 1) {
          upsell_title = upsell_title.replace(" Cover", "");
        }


        // Price - from last available varint
        var price;
        if(product_item.variants.length > 0) {
          var variant = product_item.variants[product_item.variants.length - 1];

          // This was to see if there is a variant with stock available, however changed this to now show nothing if not all variants available, as it could make some people add a cushion assuming its filled when it isnt
          // for (let i = product_item.variants.length - 1; i >= 0; i--) {
          //   if(product_item.variants[i].variant_max_quantity > 0) {
          //     variant = product_item.variants[i];
          //     break;
          //   }
          // }

          price = format_money_js(variant.variant_price, "integer");
          if(variant.variant_compare_price && variant.variant_compare_price > variant.variant_price) {
            price = '<span class="compare_at_price">' + (format_money_js(variant.variant_compare_price, "integer")) + "</span>" + price;
          }
        }

        return `
        <div class="cart_upsell_lineitem product-item__" data-product-id="${product_item.product_id}">
            <a href="${product_item.product_url}">
              <img src="${product_item.product_image}" alt="${product_item.product_title}">
              <h4>${upsell_title}</h4>
              <div class="price">${price}</div>
            </a>
            <span class="button02 add-to-cart" onclick=" product_item_add_to_cart(this)" variant_id="${variant.variant_id}" data-has-loc>Lägg till</span>
        </div>
        `;
      
      }
    }
  }



  
  // ----------------------------------------------------------------------
  /* Cart Service - Restore Removed Items */


/*
  class CARTSERVICE__Restore_Removed_Items {
    constructor (cart){
      this.cart = cart;
      this.start();
    }
    start(){
      console.log("C1")
    }
  }
*/

  // ----------------------------------------------------------------------
  /* Cart Service - Wishlisted_Items */
/*
  class CARTSERVICE__Wishlisted_Items {
    constructor (cart){
      this.cart = cart;
      this.run();
    }
    run(){
      console.log("C2");
    }
  }
*/

  // ----------------------------------------------------------------------
  /* Cart Service - Coupon_Code */
/*
  class CARTSERVICE__Coupon_Code {
    constructor (cart){
      this.cart = cart;
      this.run();
    }
    run(){
      console.log("C3");
      // Input box, which when triggered sends a post request to '...bigberthaoriginal.com/discount/${discountCode}'  -  Drawback is, only can add one without overwriting the others... maybe put a msg after 1 saying, to add multiple discounts, please do so at checkout
    }
  }
*/

  var Master_Cart = "Status: Awaiting 'invoke_cart()'"; // This string is replaced by the class when called
  function invoke_cart(object){

      Master_Cart = new Main_Cart();

      if(object) {
        Master_Cart.input_liquid_data = object;
      }


      // Create skeleton node for 
      /*
      const CS_Restore_Removed_Items = new CARTSERVICE__Restore_Removed_Items(Master_Cart);
      const CS_Wishlisted_Items = new CARTSERVICE__Wishlisted_Items(Master_Cart);
      const CS_Coupon_Code = new CARTSERVICE__Coupon_Code(Master_Cart);
      */
      try {
        Master_Cart.CS__Add_Line_item_Upsell_Items = new CARTSERVICE__Add_Line_item_Upsell_Items(Master_Cart);
      }
      catch(err) {
        console.error("Error creating Add Line Item Upsell Items service: ", err);
      }

      
      Master_Cart.init();

  }



